export class QuickSearchCriteria {
    public constructor(init?: Partial<QuickSearchCriteria>) {
      Object.assign(this, init);
    }
    lotNumber: string;
    customerType:  string;
    invoiceNumber:  string;
    parkerName:  string;
    companyName:  string;
    invoiceType:  string;
    zeroBalance:  number;
    revenueStartDate:  string;
    revenueEndDate:  string;
    transactionStartDate:  string;
    transactionEndDate:  string;
    rate:  number;
    startDateForQuery: string;
   }


